<ng-container [formGroup]="formGroup()">
    <div class="grid grid-cols-2 gap-x-2 gap-y-0.5">
        @if (displayStyle().hasSymbol) {
            <div class="form-field pt-0">
                <label class="form-control-label">{{ 'symbol' | transloco }}</label>
                <mat-form-field
                    appearance="outline"
                    class="text-sm w-full">
                    <mat-select
                        formControlName="symbol"
                        (selectionChange)="onChangeSymbol($event)">
                        @for (sprite of sprites(); track sprite.name) {
                            <mat-option [value]="sprite.name">
                                <span
                                    class="mr-2"
                                    [ngStyle]="sprite.style"></span>
                                {{ `sprites.${sprite.name}` | transloco }}
                            </mat-option>
                        }
                    </mat-select>

                    @for (error of formGroup().controls.symbol.errors | keyvalue; track error) {
                        <mat-error class="max-h-4 text-xs">
                            {{ formService.getErrorMessage(error) }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }

        @if (displayStyle().hasColor) {
            <div class="form-field pt-0">
                <label class="form-control-label">{{ 'color' | transloco }}</label>
                <mat-form-field
                    appearance="outline"
                    subscriptSizing="dynamic">
                    <fa-icon
                        class="mx-2"
                        matIconPrefix
                        size="2x"
                        [icon]="['fas', 'circle-small']"
                        [style.color]="color()" />

                    <input
                        class="text-ellipsis"
                        formControlName="color"
                        matInput
                        type="text"
                        [matMenuTriggerFor]="colorPickerMenu" />

                    @for (error of formGroup().controls.color.errors | keyvalue; track error.key) {
                        <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                    }
                </mat-form-field>

                <mat-menu
                    #colorPickerMenu="matMenu"
                    class="color-picker-menu"
                    [overlapTrigger]="false">
                    <color-sketch
                        [color]="color()"
                        (click)="$event.stopPropagation()"
                        (onChangeComplete)="onChangeColor($event)" />
                </mat-menu>
            </div>
        }

        @if (displayStyle().hasSize) {
            <div class="form-field pt-0">
                <label class="form-control-label">
                    {{ (geometry() === MapboxStyle.TypeEnum.LINE ? 'lineSize' : 'symbolSize') | transloco }}
                </label>

                <mat-form-field
                    appearance="outline"
                    class="text-sm">
                    <input
                        formControlName="size"
                        matInput
                        min="0"
                        step="1"
                        type="number" />

                    @for (error of formGroup().controls.size?.errors | keyvalue; track error) {
                        <mat-error class="max-h-4 text-xs">
                            {{ formService.getErrorMessage(error) }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }

        @if (displayStyle().hasOpacity) {
            <div class="form-field pt-0">
                <label class="form-control-label">{{ 'opacity' | transloco }}</label>
                <mat-form-field
                    appearance="outline"
                    class="text-sm">
                    <input
                        formControlName="opacity"
                        matInput
                        max="1"
                        min="0"
                        step="0.1"
                        type="number" />

                    @for (error of formGroup().controls.opacity.errors | keyvalue; track error) {
                        <mat-error class="max-h-4 text-xs">
                            {{ formService.getErrorMessage(error) }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }

        @if (displayStyle().hasSymbolOpacity) {
            <div class="form-field pt-0">
                <label class="form-control-label">{{ 'symbolOpacity' | transloco }}</label>
                <mat-form-field
                    appearance="outline"
                    class="text-sm">
                    <input
                        formControlName="symbolOpacity"
                        matInput
                        max="1"
                        min="0"
                        step="0.1"
                        type="number" />

                    @for (error of formGroup().controls.symbolOpacity?.errors | keyvalue; track error) {
                        <mat-error class="max-h-4 text-xs">
                            {{ formService.getErrorMessage(error) }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }

        @if (displayStyle().hasZooms) {
            <div class="form-field pt-0">
                <label class="form-control-label">{{ 'minZoom' | transloco }}</label>
                <mat-form-field
                    appearance="outline"
                    class="text-sm">
                    <input
                        formControlName="minZoom"
                        matInput
                        max="24"
                        min="1"
                        step="1"
                        type="number" />

                    @for (error of formGroup().controls.minZoom.errors | keyvalue; track error) {
                        <mat-error class="max-h-4 text-xs">
                            {{ formService.getErrorMessage(error) }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="form-field pt-0">
                <label class="form-control-label">{{ 'maxZoom' | transloco }}</label>
                <mat-form-field
                    appearance="outline"
                    class="text-sm">
                    <input
                        formControlName="maxZoom"
                        matInput
                        max="24"
                        min="1"
                        step="1"
                        type="number" />

                    @for (error of formGroup().controls.maxZoom.errors | keyvalue; track error) {
                        <mat-error class="max-h-4 text-xs">
                            {{ formService.getErrorMessage(error) }}
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
    </div>
</ng-container>
